module.exports = __webpack_public_path__ + "static/media/Team-Wenjie.7142b329.jpg";